<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-number"><span><a href="#/toc#toc-part001">Part One</a></span></h1>
<h1 class="part-title"><span><a href="#/toc#toc-part001">The Friend of the Shoemaker</a></span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?79c21e95